import { Constants } from "appConstants";
import { IcoArrowLeft, IcoArrowRight } from "assets/icons";
import { Button } from "components";
import { useState } from "react";
import "./styles.scss";

export type PaginationProps = {
	numberOfInstancesOptions: number[];
	totalPages: number;
	currentPage: number;
	onPageChange: (selectedPage: number, pageSize: number) => void;
	pageSize: number;
	cssCompact?: boolean;
};

export default function Pagination({
	numberOfInstancesOptions,
	totalPages,
	currentPage,
	onPageChange,
	pageSize,
	cssCompact = false
}: Readonly<PaginationProps>) {
	const [currentSelectedPage, setCurrentSelectedPage] = useState(currentPage);

	return (
		<div
			className={`table-pagination ${
				cssCompact ? "p-6" : "px-4 py-2 mt-6 ml-8 mr-8"
			}`}
		>
			<span className="page-size-selector">
				<select
					value={pageSize}
					onChange={(event) => {
						setCurrentSelectedPage(1);
						onPageChange(1, +event.target.value);
					}}
				>
					{numberOfInstancesOptions.map((option: number) => (
						<option key={option}>{option}</option>
					))}
				</select>
				{Constants.strings.pages.listing.pagination}
			</span>
			<div className="page-num-selector">
				<Button
					kind="icon"
					styled="ghost"
					onClick={() => {
						setCurrentSelectedPage(currentSelectedPage - 1);
						onPageChange(currentSelectedPage - 1, pageSize);
					}}
					disabled={currentPage <= 1}
				>
					<IcoArrowLeft size="24" />
				</Button>
				<div className="page-selector">
					<input
						className="page-number-input"
						type="number"
						max={totalPages}
						min={1}
						step={1}
						value={currentSelectedPage.toString()}
						onChange={(event) => {
							const value = +event.target.value;
							setCurrentSelectedPage(value);
						}}
						onKeyDown={(event) => {
							if (event.key === "Enter") {
								if (
									currentSelectedPage >= 1 &&
									currentSelectedPage <= totalPages
								) {
									onPageChange(currentSelectedPage, pageSize);
								}
							}
						}}
					/>
					<span>de {`${totalPages}`}</span>
				</div>
				<Button
					kind="icon"
					styled="ghost"
					onClick={() => {
						setCurrentSelectedPage(currentSelectedPage + 1);
						onPageChange(currentSelectedPage + 1, pageSize);
					}}
					disabled={currentPage >= totalPages}
				>
					<IcoArrowRight size="24" />
				</Button>
			</div>
		</div>
	);
}
